<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.productcategory') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-data-table-server v-model:items-per-page="itemsPerPage" :items-per-page-options="pageOptions"
                density="compact" :headers="headers" :items="serverItems" :items-length="totalItems" :loading="loading"
                :search="search" item-value="name" @update:options="loadItems" @update:page="updatePage" height="60vh" :update:sortBy="updateSortBy"
                :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)" class="shop-list-table" fixed-header>
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                            <v-text-field v-model="search" :disabled="false"
                                :placeholder="$t('main.search.placeholder')" variant="outlined" hide-details="true"
                                density="compact" class="pb-2 py-0 bg-white" height="32px">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn color="primary" variant="flat" class="mr-1" rounded="xl" size="large"
                                @click="showDialog = true">
                                {{ $t('global.menu.backoffice.createProductCategory') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:[`item.areas`]="props">
                    <v-btn size="x-small" class="px-0" variant="outlined" @click="() => editAreas(props.item)"> {{
                        props.item.areas ?
                            props.item.areas.length : null }}
                    </v-btn>
                </template>
                <template v-slot:[`item.active`]="{ value }">
                    <!-- {{ value }} -->
                    <v-tooltip>
                        <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" color="success" size="32" v-if="value">mdi-toggle-switch</v-icon>
                            <v-icon v-bind="props" color="error" size="32" v-else>mdi-toggle-switch-off</v-icon>
                        </template>
                        <span v-if="value">active</span>
                        <span v-else>inactive</span>
                    </v-tooltip>
                </template>

                <template v-slot:[`item.translations`]="props">
                    <!-- {{ props.item?.translations[selectedLanguage.toUpperCase()]?.value }} -->
                    <!-- {{ props.item.translations[selectedLanguage.toUpperCase()].value }} -->
                    {{ props.item.translations ? props.item?.translations[selectedLanguage.toUpperCase()]?.value :
                        props.item.name }}
                </template>
                <template v-slot:[`item.controls`]="props">
                    <v-btn color="primary" variant="flat" size="32" class="mr-1"
                        @click="() => editProductCategory(props.item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn color="error" variant="flat" size="32" class="mr-1"
                        @click="() => removeProductCategory(props.item)">
                        <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                </template>

            </v-data-table-server>
        </v-row>
        <ShopAreasDialog v-model="showAreasDialog" v-model:data="newProductCategory" :items="mappedData"
            :save="updateProductCategoryAreas" type="productCategory">
        </ShopAreasDialog>
        <CreateProductCategoryDialog v-model="showDialog" v-model:data="newProductCategory" :save="save">
        </CreateProductCategoryDialog>
        <CustomConfirmDeletionDialog v-model="showDeleteDialog" v-model:data="removedProductCategory"
            :confirm-deletion="deleteProductCategory">
        </CustomConfirmDeletionDialog>
    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import CreateProductCategoryDialog from './modals/CreateProductCategoryDialog.vue';
import CustomConfirmDeletionDialog from './modals/CustomConfirmDeletionDialog.vue';
import ShopAreasDialog from './modals/ShopAreasDialog.vue';

export default {
    components: {
        CreateProductCategoryDialog,
        CustomConfirmDeletionDialog,
        ShopAreasDialog
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const newProductCategory = ref({})
        const removedProductCategory = ref({})
        const showDialog = ref(false)
        const showAreasDialog = ref(false)
        const showDeleteDialog = ref(false)
        const softToken = localStorage.getItem("softToken");
        const hardToken = localStorage.getItem("hardToken");
        const username = localStorage.getItem("username");

        const updatePage = (newPage) => {
            proxy.page = newPage;
        }

        const updateSortBy = (newSort) => {
            proxy.sortBy = newSort;
        }

        const editProductCategory = (item) => {

            newProductCategory.value = { ...item };
            showDialog.value = true;
        }

        const updateProductCategoryAreas = async () => {
            // /api/backoffice/productcategory/2699f187-d40f-43c8-9869-8b4ba34574b7
            const copy = { ...newProductCategory.value }
            console.log(copy);
            // try {
            //         const response = await proxy.$axios.put(`/backoffice/productcategory/${newProductCategory.value.id}`, copy, {
            //             headers: {
            //                 'X-Auth-HARDTOKEN': hardToken,
            //                 'X-Auth-SOFTTOKEN': softToken,
            //                 'X-Auth-USER': username
            //             },
            //         });

            //         if (response.data.status == "OK") {
            //             showDialog.value = false;
            //             proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage });
            //         }
            //     } catch (error) {
            //         console.error("Error fetching search results:", error);
            //     }
        }   
        const editAreas = (item) => {
            showAreasDialog.value = true;
            newProductCategory.value = { ...item };
        }

        const save = async () => {
            if (newProductCategory.value.id) {
                const copy = { ...newProductCategory.value }

                try {
                    const response = await proxy.$axios.put(`/backoffice/productcategory/${newProductCategory.value.id}`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });

                    if (response.data.status == "OK") {
                        showDialog.value = false;
                        proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                    }
                } catch (error) {
                    console.error("Error fetching search results:", error);
                }
            } else {
                const copy = { ...newProductCategory.value }

                try {
                    const response = await proxy.$axios.post(`/backoffice/productcategory`, copy, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    });

                    if (response.data.status == "OK") {
                        showDialog.value = false;
                        proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                    }
                } catch (error) {
                    console.error("Error fetching search results:", error);
                }
            }
        }
        const removeProductCategory = (item) => {
            removedProductCategory.value = item;
            showDeleteDialog.value = true;
        }

        const deleteProductCategory = async (item) => {
            try {
                const response = await proxy.$axios.delete(`/backoffice/productcategory/${item.id}`, {
                    headers: {
                        'X-Auth-HARDTOKEN': hardToken,
                        'X-Auth-SOFTTOKEN': softToken,
                        'X-Auth-USER': username
                    },
                });

                if (response.data.status == "OK") {
                    showDeleteDialog.value = false;
                    proxy.loadItems({ page: proxy.page, itemsPerPage: proxy.itemsPerPage, sortBy:proxy.sortBy });
                }
            } catch (error) {
                console.error("Error fetching search results:", error);
            }
        }

        const countries = ref([]);
        const districts = ref([]);
        const mappedData = ref([]);

        const fetchData = async () => {
            try {
                const [countriesRes, districtsRes] = await Promise.all([
                    proxy.$axios.get(`/backoffice/country/all`, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    }),
                    proxy.$axios.get(`/backoffice/cities`, {
                        headers: {
                            'X-Auth-HARDTOKEN': hardToken,
                            'X-Auth-SOFTTOKEN': softToken,
                            'X-Auth-USER': username
                        },
                    })
                ]);

                if (countriesRes.data.status === "OK") {
                    countries.value = countriesRes.data.data;
                }
                if (districtsRes.data.status === "OK") {
                    districts.value = districtsRes.data.data;
                }

                // ✅ Map Data Only Once
                const objectMap = new Map((districts.value || []).map(obj => [obj.id, obj]));
                mappedData.value = (countries.value || []).map(group => ({
                    ...group,
                    // preloadedChildren: group.areaIds.map(id => objectMap.get(id)).filter(Boolean),
                    children: group.areaIds.map(id => objectMap.get(id)).filter(Boolean),
                    // children:[]
                }));

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        onMounted(() => {
            fetchData();
        });
        return {
            selectedLanguage,
            newProductCategory,
            removedProductCategory,
            showDialog,
            showDeleteDialog,
            updatePage,
            editProductCategory,
            save,
            deleteProductCategory,
            removeProductCategory,
            updateProductCategoryAreas,
            showAreasDialog,
            editAreas,
            mappedData,
            updateSortBy
        };
    },

    watch: {

    },

    data: () => ({
        page: 1,
        itemsPerPage: 50,
        sortBy:[],
        pageOptions: [
            { value: 50, title: '50' },
            { value: 100, title: '100' },
            { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
        ],
        headers: [
            { title: 'Name', key: 'translations', align: 'start', maxWidth: "200px" },
            { title: 'FrontendId', key: 'frontendId', align: 'start' },
            { title: 'sortOrder', key: 'position', align: 'start' },
            { title: 'areas', value: "areas", align: 'start', maxWidth: '50px' },
            { title: 'active', value: "active", align: 'start', maxWidth: '50px' },
            { title: 'Actions', value: "controls", align: 'end', sortable: false },
        ],
        search: '',
        serverItems: [],
        loading: true,
        totalItems: 0,
    }),

    computed: {
    },

    mounted() {
    },

    methods: {
        loadItems({ page, itemsPerPage, sortBy }) {
            this.loading = true
            console.log(this.search)
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            this.$axios.get(this.search.length >= 1 ? "/backoffice/productcategories/query" : "/backoffice/productcategories", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
                params: {
                    sortColumn: sortBy[0]?.key,
                    sortDirection: sortBy[0]?.order.toUpperCase(),
                    activeOnly: false,
                    ...(this.search.length >= 1 ? { lang: this.selectedLanguage.toUpperCase(), search: this.search, resultsPerPage: itemsPerPage, page: page - 1 } : { lang: this.selectedLanguage.toUpperCase(), page: page - 1, resultsPerPage: itemsPerPage })
                }
            })
                .then(this.itemsFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        itemsFetched(response) {
            console.log(response)
            this.serverItems = response.data.data;
            this.totalItems = response.data.totalElements
            this.loading = false
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
    margin-top: 40px;
}
</style>

<style></style>

<style></style>